import { membersApi } from "@services/apiMembersClient";
import {
  CreateModuleInput,
  EditReorderModulesInput,
  GetModuleByIdInput,
  GetModuleByIdOutput,
  GetModuleBySearchInput,
  GetModuleBySearchOutput,
  GetModuleInput,
  GetModuleOutput,
  UpdateModuleInput,
} from "@_types/modules";
import { PaginationType, ResponsePaginationType, SearchParams } from "@_types/shared";
import { AxiosPromise } from "axios";

export const getModules = (
  params: GetModuleInput & PaginationType
): AxiosPromise<ResponsePaginationType<GetModuleOutput>> => {
  return membersApi.get(`/modules`, {
    params,
  });
};

export const getModule = ({ uuid }: GetModuleByIdInput): AxiosPromise<GetModuleOutput> => {
  return membersApi.get(`/modules/${uuid}`);
};

export const createModule = (data: CreateModuleInput): AxiosPromise<{ uuid: string }> => {
  return membersApi.post(`/modules`, data);
};

export const updateModule = ({ uuid, ...data }: UpdateModuleInput): AxiosPromise<{ uuid: string }> => {
  return membersApi.patch(`/modules/${uuid}`, data);
};

export const getModuleById = ({ uuid }: GetModuleByIdInput): AxiosPromise<GetModuleByIdOutput> => {
  return membersApi.get(`/modules/${uuid}`);
};

export const getModuleBySearch = ({
  ...params
}: GetModuleBySearchInput & SearchParams): AxiosPromise<GetModuleBySearchOutput[]> => {
  return membersApi.get(`/modules/search`, {
    params: { ...params },
  });
};

export const deleteModuleById = ({ uuid }: GetModuleByIdInput): AxiosPromise<GetModuleByIdOutput> => {
  return membersApi.delete(`/modules/${uuid}`);
};

export const editReorderModules = ({ modules }: EditReorderModulesInput): AxiosPromise<{ uuid: string }> => {
  return membersApi.patch<{ uuid: string }>(`/modules/reorder`, { modules });
};
